import React, { useState } from 'react';
import './Socialicons.css';

const SocialIcons = () => {
    const [showIcons, setShowIcons] = useState(false);

    const toggleIcons = () => {
        setShowIcons(!showIcons);
    };

    return (

        <>
           <div className='icons whatsapps'>
             <a
                    href="https://wa.me/917405649537"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon whatsapp"
                >
                    <i className="fab fa-whatsapp"></i>
                </a>
           </div>
        
        
       




        <div className="social-icons-wrapper">
            {/* Toggle Button */}
            <button
                className={`toggle-button ${showIcons ? '' : 'glow'}`}
                onClick={toggleIcons}
            >
                <i className="fas fa-share-alt"></i>
            </button>


            {/* Social Icons Panel */}
            <div className={`social-icons-vertical ${showIcons ? 'show' : ''}`}>
                <a
                    href="https://www.instagram.com/globallinkcorporation?igsh=MWJmbDlleGFya2tzbQ=="
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon instagram"
                >
                    <i className="fab fa-instagram"></i>
                </a>
                <a
                    href="https://www.linkedin.com/company/global-link-corporation/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon linkedin"
                >
                    <i className="fab fa-linkedin-in"></i>
                </a>
                <a
                    href="https://wa.me/917405649537"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon whatsapp"
                >
                    <i className="fab fa-whatsapp"></i>
                </a>
                <a
                    href="https://x.com/globalinkcorp?s=11"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon twitter"
                >
                    <i className="fab fa-twitter"></i>
                </a>
            </div>
        </div>
         </>
    );
};

export default SocialIcons;
